"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var LockupText = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: inline-block;\n"], ["\n\tdisplay: inline-block;\n"])));
var Head = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n\twhite-space: nowrap;\n"], ["\n\t", "\n\twhite-space: nowrap;\n"])), function (props) { return props.theme.lockup.head; });
var Body = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.lockup.body; });
var Lockup = /** @class */ (function (_super) {
    __extends(Lockup, _super);
    function Lockup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Lockup.prototype.render = function () {
        return (react_1.default.createElement(LockupText, { className: this.props.className },
            react_1.default.createElement(Head, null, this.props.headText),
            react_1.default.createElement(Body, null, this.props.bodyText)));
    };
    Lockup.propTypes = {
        headText: prop_types_1.default.string.isRequired,
        bodyText: prop_types_1.default.string.isRequired,
        className: prop_types_1.default.string,
    };
    return Lockup;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Lockup);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Lockup.js.map